import { SendEmailRequest, SendEmailResponse } from './types';
import { REACT_APP_EMAIL_API_KEY, REACT_APP_EMAIL_API_URL, REACT_APP_EMAIL_APPLICATION_ID, REACT_APP_EMAIL_TEMPLATE_SCHEDULING } from '../../config';
import { uuidv4 } from 'services/common';
import * as Sentry from '@sentry/react';

const sendEmail = async (data: SendEmailRequest): Promise<SendEmailResponse> => {
  try {
    const response = await fetch(REACT_APP_EMAIL_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Api-Key': REACT_APP_EMAIL_API_KEY,
        'X-Application-Id': REACT_APP_EMAIL_APPLICATION_ID,
        'X-Request-ID': uuidv4()
      },
      body: JSON.stringify(data)
    });
    if (!response.ok) {
      Sentry.logger.error('emailService[sendEmail] error', { status: response.status, message: await response.text() });
      throw new Error('Error sending email');
    }
    const r = await response.json() as SendEmailResponse;
    Sentry.logger.info('emailService[sendEmail]', { response: r });
    return r;
  } catch (error) {
    Sentry.logger.error('emailService[sendEmail] unexpected error', { error: error });
    console.error('[send email]', error);
    throw error;
  }
};

interface SchedulingConfirmationParams {
  firstName: string;
  email: string;
  name?: string;
  subject: string;
}

const sendSchedulingConfirmationEmail = async ({ firstName, email, name, subject }: SchedulingConfirmationParams): Promise<SendEmailResponse> => {
  return sendEmail({
    subject,
    to: { email, name: name || firstName },
    template_id: parseInt(REACT_APP_EMAIL_TEMPLATE_SCHEDULING, 10),
    params: { FIRSTNAME: firstName },
    attachment: []
  });
};

export { sendEmail, sendSchedulingConfirmationEmail };
